import type { RestOAuthConfig } from '../entities.tsx';

export type AuthType =
	| 'oauthWithImpersonation'
	| 'oauth'
	| 'disabled'
	| 'unknown'
	| 'oauth2ThreeLo';
export const AUTH_OAUTH1_IMPERSONATION: AuthType = 'oauthWithImpersonation';
export const AUTH_OAUTH1: AuthType = 'oauth';
export const AUTH_DISABLED: AuthType = 'disabled';
export const AUTH_UNKNOWN: AuthType = 'unknown';

// This one should never be shown to the user (as this page is for OAuth 1.0), but
// in the event it is, provides a 'more correct' value for troubleshooting.
export const AUTH_OAUTH2: AuthType = 'oauth2ThreeLo';

export const getAuthLevel = (config?: RestOAuthConfig): AuthType => {
	if (!config) {
		return AUTH_UNKNOWN;
	}
	if (config.enabled && config.twoLoEnabled && config.twoLoImpersonationEnabled) {
		return AUTH_OAUTH1_IMPERSONATION;
	}
	if (config.enabled && !config.twoLoImpersonationEnabled) {
		return AUTH_OAUTH1;
	}
	if (config.oAuth2ThreeLoEnabled) {
		return AUTH_OAUTH2;
	}
	if (
		!config.enabled &&
		!config.twoLoEnabled &&
		!config.twoLoImpersonationEnabled &&
		!config.oAuth2ThreeLoEnabled
	) {
		return AUTH_DISABLED;
	}
	return AUTH_UNKNOWN;
};
